var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"options":_vm.options,"props":_vm.props,"size":_vm.size,"disabled":_vm.disabled,"clearable":"","filterable":""},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }